export default {
  app: () => import("/project/layouts/app.vue").then(m => m.default || m),
  default: () => import("/project/layouts/default.vue").then(m => m.default || m),
  loading: () => import("/project/layouts/loading.vue").then(m => m.default || m)
}